import { render, staticRenderFns } from "./coreBussinessContent.vue?vue&type=template&id=9f61580a&scoped=true&"
import script from "./coreBussinessContent.vue?vue&type=script&lang=js&"
export * from "./coreBussinessContent.vue?vue&type=script&lang=js&"
import style0 from "./coreBussinessContent.vue?vue&type=style&index=0&id=9f61580a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f61580a",
  null
  
)

export default component.exports